import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Global error handler for mobile debugging
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);

    // Prevent default error handling
    event.preventDefault();

    // Show user-friendly error message
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);color:white;padding:20px;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;';

    errorDiv.innerHTML = `
      <div style="font-size:80px;margin-bottom:20px;">😕</div>
      <h2 style="margin:0 0 15px 0;font-size:24px;">页面加载出错</h2>
      <p style="margin:0 0 10px 0;font-size:14px;opacity:0.9;max-width:300px;">${event.message}</p>
      <p style="margin:0 0 20px 0;font-size:12px;opacity:0.7;">${event.filename}:${event.lineno}</p>
      <button onclick="location.reload()" style="background:white;color:#667eea;border:none;padding:12px 30px;border-radius:25px;font-size:16px;font-weight:bold;cursor:pointer;">刷新页面</button>
      <button onclick="navigator.clipboard.writeText('${event.message}').then(() => alert('错误信息已复制'))" style="background:transparent;color:white;border:1px solid white;padding:10px 25px;border-radius:25px;font-size:14px;cursor:pointer;margin-top:10px;">复制错误信息</button>
    `;
    document.body.innerHTML = '';
    document.body.appendChild(errorDiv);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);

    // Show error for promise rejections too
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'position:fixed;top:0;left:0;right:0;background:#ff4444;color:white;padding:20px;z-index:99999;';
    errorDiv.innerHTML = `
      <h3>⚠️ 应用错误</h3>
      <p style="font-size:12px;">${event.reason?.message || event.reason || '未知错误'}</p>
      <button onclick="this.parentElement.remove()" style="margin-top:10px;padding:5px 15px;">关闭</button>
    `;
    document.body.appendChild(errorDiv);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);